import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { BillingAccessGuard } from 'modules/billing/components/BillingAccessGuard';
import { homeRoutesConfig } from 'domains/home/routes';
import { Page } from 'modules/layout/components/Page';

const CardPaymentSuccessPage = loadable(
  async () => {
    const module = await import('./CardPaymentSuccessPage');

    return module.CardPaymentSuccessPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);
const homePath = homeRoutesConfig.home.generatePath();

export const CardPaymentSuccessPageContainer = () => {
  return (
    <Page>
      <BillingAccessGuard fallback={<Navigate to={homePath} replace />}>
        <CardPaymentSuccessPage />
      </BillingAccessGuard>
    </Page>
  );
};
